import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { forwardRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Rectangle,
  CircleMarker,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import api from "../api/axiosInstance";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import StyledInput from "./StyledInput";
import { ModernButton } from "./ModernButton";

const IconDateButton = forwardRef(({ value, onClick, label }, ref) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      type="button"
      className="
        flex items-center gap-2
        px-2 py-1
        rounded-md bg-white
        border border-gray-300
        whitespace-nowrap
        w-[120px]
      "
    >
      <svg
        className="w-4 h-4 text-gray-600 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>

      <span className="text-sm text-gray-800 text-left">
        {value || label}
      </span>
    </button>
  );
});
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
//   Rectangle,
//   CircleMarker,
//   useMap,
// } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import api from "../api/axiosInstance";
// import {
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   OutlinedInput,
//   Checkbox,
//   ListItemText,
// } from "@mui/material";

// // Fix default marker icon issue
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
//   iconUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
//   shadowUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
// });

// // 🔹 Smooth focus to selected markers
// function MapAutoFocus({ sheds }) {
//   const map = useMap();

//   useEffect(() => {
//     if (sheds.length > 0) {
//       const bounds = L.latLngBounds(sheds.map((s) => [s.latStart, s.longStart]));
//       map.flyToBounds(bounds, {
//         padding: [80, 80],
//         maxZoom: 15,
//         duration: 1.8, // smooth transition
//       });
//     }
//   }, [sheds, map]);

//   return null;
// }

// export default function MapViewTab(fromDate, toDate, applyClicked) {
//   const [search, setSearch] = useState("");
//   const [blockFilter, setBlockFilter] = useState([]);
//   const [panchayatFilter, setPanchayatFilter] = useState([]);
//   const [sheds, setSheds] = useState([]);
//   const [blocks, setBlocks] = useState([]);
//   const [panchayats, setPanchayats] = useState([]);
//   const [filteredSheds, setFilteredSheds] = useState([]);
// const roleId = parseInt(localStorage.getItem("roleId"));
// const savedBlockName = localStorage.getItem("blockName");
// const savedPanchayatName = localStorage.getItem("panchayatName");
//   // ✅ Fetch Compost Shed data
//   useEffect(() => {
//     api
//       .get("/CompostShed")
//       .then((res) => {
//         if (res.data.success && Array.isArray(res.data.data)) {
//           setSheds(res.data.data);
//         }
//       })
//       .catch((err) => console.error("Error fetching Compost Sheds:", err));
//   }, []);

//   // ✅ Fetch Blocks
//   useEffect(() => {
//     api
//       .get("/Block")
//       .then((res) => {
//         if (res.data.success && Array.isArray(res.data.data)) {
//           setBlocks(res.data.data);
//         }
//       })
//       .catch((err) => console.error("Error fetching Blocks:", err));
//   }, []);

//   // ✅ Update Panchayats when Block changes
//   useEffect(() => {
//     if (blockFilter.length > 0) {
//       const selectedBlocks = blocks.filter((b) => blockFilter.includes(b.name));
//       const combinedPanchayats = selectedBlocks.flatMap((b) => b.panchayats || []);
//       const uniquePanchayats = Array.from(
//         new Map(combinedPanchayats.map((p) => [p.panchayatId, p])).values()
//       );
//       setPanchayats(uniquePanchayats);
//     } else {
//       setPanchayats([]);
//     }
//     setPanchayatFilter([]);
//   }, [blockFilter, blocks]);

//   // ✅ Filter sheds
//   const filteredData = sheds.filter(
//     (d) =>
//       (!search ||
//         d.blockName.toLowerCase().includes(search.toLowerCase()) ||
//         d.panchayatName.toLowerCase().includes(search.toLowerCase())) &&
//       (blockFilter.length === 0 || blockFilter.includes(d.blockName)) &&
//       (panchayatFilter.length === 0 || panchayatFilter.includes(d.panchayatName))
//   );

//   // ✅ Filter by date range
//   useEffect(() => {
//     if (!sheds.length) return;
//     const filtered = sheds.filter((s) => {
//       const date = new Date(s.date);
//       return date >= new Date(fromDate) && date <= new Date(toDate);
//     });
//     setFilteredSheds(filtered);
//   }, [applyClicked, fromDate, toDate]);

//   return (
//     <div className="p-0">
//       {/* 🔹 Filter Bar */}
//       <div className="flex flex-wrap items-center gap-2 p-2 bg-yellow-500 text-gray-900 shadow-md rounded-lg">
//         {/* Search Box */}
//         <input
//           type="text"
//           placeholder="Search by Block / Panchayat"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="border p-2 rounded w-64"
//         />

//         {/* 🏗️ Block Dropdown */}
//         <FormControl sx={{ minWidth: 200 }} size="small">
//           <InputLabel shrink={true}>Blocks</InputLabel>
//           <Select
//             multiple
//             displayEmpty
//             value={blockFilter}
//             onChange={(e) => setBlockFilter(e.target.value)}
//             input={<OutlinedInput label="Blocks" />}
//             renderValue={(selected) =>
//               selected.length === 0 ? "Select Blocks" : `${selected.length} Selected`
//             }
//             MenuProps={{ PaperProps: { style: { maxHeight: 300, width: 250 } } }}
//           >
//             {blocks.map((block) => (
//               <MenuItem key={block.blockId} value={block.name} sx={{ py: 0.2, minHeight: "28px" }}>
//                 <Checkbox
//                   checked={blockFilter.indexOf(block.name) > -1}
//                   sx={{ p: 0.3, transform: "scale(0.8)" }}
//                 />
//                 <ListItemText primary={block.name} primaryTypographyProps={{ fontSize: "0.8rem" }} />
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         {/* 🏘️ Panchayat Dropdown */}
//         <FormControl sx={{ minWidth: 200 }} size="small">
//           <InputLabel shrink={true}>Panchayats</InputLabel>
//           <Select
//             multiple
//             displayEmpty
//             value={panchayatFilter}
//             onChange={(e) => setPanchayatFilter(e.target.value)}
//             input={<OutlinedInput label="Panchayats" />}
//             renderValue={(selected) =>
//               selected.length === 0 ? "Select Panchayats" : `${selected.length} Selected`
//             }
//             MenuProps={{ PaperProps: { style: { maxHeight: 300, width: 250 } } }}
//           >
//             {panchayats.map((p) => (
//               <MenuItem key={p.panchayatId} value={p.name} sx={{ py: 0.2, minHeight: "28px" }}>
//                 <Checkbox
//                   checked={panchayatFilter.indexOf(p.name) > -1}
//                   sx={{ p: 0.3, transform: "scale(0.8)" }}
//                 />
//                 <ListItemText primary={p.name} primaryTypographyProps={{ fontSize: "0.8rem" }} />
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </div>

//       {/* 🗺️ Map Section */}
//       <div className="h-[600px] w-full mt-4">
//         <MapContainer
//           center={[12.9716, 77.5946]}
//           zoom={8}
//           scrollWheelZoom={true}
//           style={{ height: "100%", width: "100%" }}
//         >
//           <TileLayer
//             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
//           />

//           {/* Smooth Auto Focus */}
//           <MapAutoFocus sheds={filteredData} />

//           {/* ✅ Markers + Pulsing Highlight */}
//           {filteredData.map((shed) => (
//             <React.Fragment key={shed.shedId}>
//               <CircleMarker
//                 center={[shed.latStart, shed.longStart]}
//                 radius={15}
//                 pathOptions={{
//                   color: "rgba(0, 200, 0, 0.4)",
//                   weight: 2,
//                   fillColor: "rgba(0, 255, 0, 0.2)",
//                   fillOpacity: 0.4,
//                 }}
//                 className="animate-ping"
//               />
//               <Marker position={[shed.latStart, shed.longStart]}>
//                 <Popup>
//                   <div>
//                     <strong>Shed ID:</strong> {shed.shedId}
//                     <br />
//                     <strong>Block:</strong> {shed.blockName}
//                     <br />
//                     <strong>Panchayat:</strong> {shed.panchayatName}
//                     <br />
//                     <strong>Lat Range:</strong> {shed.latStart} - {shed.latEnd}
//                     <br />
//                     <strong>Long Range:</strong> {shed.longStart} - {shed.longEnd}
//                   </div>
//                 </Popup>
//               </Marker>
//             </React.Fragment>
//           ))}

//           {/* ✅ Compost Shed Boundaries */}
//           {filteredData.map((shed) => {
//             const bounds = [
//               [shed.latStart, shed.longStart],
//               [shed.latEnd, shed.longEnd],
//             ];
//             return (
//               <Rectangle
//                 key={`rect-${shed.shedId}`}
//                 bounds={bounds}
//                 pathOptions={{ color: "green", weight: 1 }}
//               />
//             );
//           })}
//         </MapContainer>
//       </div>

//       <div className="text-center mt-4 text-neutral-500 text-xs italic">
//         Powered by CircularCarbon Technologies
//       </div>
//     </div>
//   );
// }


 

// Add custom styles for Leaflet popup close button
const popupStyles = `
  .leaflet-popup-close-button {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    width: 24px !important;
    height: 24px !important;
    background: rgba(255, 255, 255, 0.9) !important;
    border: none !important;
    border-radius: 0 8px 0 8px !important;
    color: #374151 !important;
    font-size: 18px !important;
    font-weight: bold !important;
    line-height: 1 !important;
    text-align: center !important;
    cursor: pointer !important;
    z-index: 1000 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;
  }
  
  .leaflet-popup-close-button:hover {
    background: rgba(255, 255, 255, 1) !important;
    color: #1f2937 !important;
    transform: scale(1.05) !important;
  }
  
  .leaflet-popup-content-wrapper {
    border-radius: 8px !important;
    overflow: hidden !important;
  }
  
  .leaflet-popup-content {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Ensure react-datepicker popper appears above map elements */
  .react-datepicker-popper {
    z-index: 99999 !important;
  }

  .react-datepicker {
    z-index: 99999 !important;
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = popupStyles;
  document.head.appendChild(styleElement);
}

// Fix default marker icon issue and create custom compost shed icon
delete L.Icon.Default.prototype._getIconUrl;

// Create custom compost shed icon
const compostShedIcon = new L.Icon({
  iconUrl: '/images/Compost_shed.png',
  iconRetinaUrl: '/images/Compost_shed.png',
  iconSize: [60, 60], // Size of the icon (increased from 50x50)
  iconAnchor: [30, 60], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -60], // Point from which the popup should open relative to the iconAnchor
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  shadowSize: [61, 61], // Size of the shadow (increased proportionally)
  shadowAnchor: [19, 61] // Anchor point of the shadow
});

// 🔹 Smooth focus to selected markers
function MapAutoFocus({ sheds }) {
  const map = useMap();

  useEffect(() => {
    if (sheds.length > 0) {
      const bounds = L.latLngBounds(sheds.map((s) => [s.latStart, s.longStart]));
      map.flyToBounds(bounds, {
        padding: [80, 80],
        maxZoom: 15,
        duration: 1.8,
      });
    }
  }, [sheds, map]);

  return null;
}

export default function MapViewTab({ fromDate, toDate, applyClicked, setFromDate, setToDate, setApplyClicked, activeRange, handleDateFilter }) {
  const [search, setSearch] = useState("");
  const [blockFilter, setBlockFilter] = useState([]);
  const [panchayatFilter, setPanchayatFilter] = useState([]);
  const [sheds, setSheds] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [panchayats, setPanchayats] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [openFromPicker, setOpenFromPicker] = useState(false);
  const [openToPicker, setOpenToPicker] = useState(false);
  const roleId = parseInt(localStorage.getItem("roleId"));
  const savedBlockName = localStorage.getItem("blockName");
  const savedPanchayatName = localStorage.getItem("panchayatName");

  // Ensure incoming dates are not in the future
  useEffect(() => {
    const today = new Date();
    const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    try {
      if (fromDate) {
        const fd = new Date(fromDate);
        if (fd > today) setFromDate(fmt(today));
      }
      if (toDate) {
        const td = new Date(toDate);
        if (td > today) setToDate(fmt(today));
      }
    } catch (e) {
      // ignore malformed dates
    }
  }, [fromDate, toDate, setFromDate, setToDate]);

  // ✅ Filter visible blocks based on role
  const visibleBlocks =
    roleId === 3 && savedBlockName
      ? blocks.filter((b) => b.name === savedBlockName)
      : blocks;

  // ✅ Fetch Compost Sheds
  useEffect(() => {
    api
      .get("/CompostShed")
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setSheds(res.data.data);
        }
      })
      .catch((err) => console.error("Error fetching Compost Sheds:", err));
  }, []);

  // ✅ Fetch Blocks
  useEffect(() => {
    api
      .get("/Block")
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          const allBlocks = res.data.data;

          // 🔸 Role-based filtering logic
          if (roleId === 1 || roleId === 2) {
            // Show all blocks
            setBlocks(allBlocks);
          } else if (roleId === 3) {
            // Show only the block matching savedBlockName
            const filtered = allBlocks.filter(
              (b) => b.name?.toLowerCase() === savedBlockName?.toLowerCase()
            );
            setBlocks(filtered);
            setBlockFilter([savedBlockName]); // preselect the block
          } else if (roleId === 4) {
            // Show all blocks but hide block dropdown
            setBlocks(allBlocks);
          }
        }
      })
      .catch((err) => console.error("Error fetching Blocks:", err));
  }, [roleId, savedBlockName]);

  // ✅ Update Panchayats when Block changes
  useEffect(() => {
    if (blocks.length === 0) return;

    // For role 1 & 2 → based on selected block(s)
    // For role 3 → auto load panchayats for savedBlockName
    // For role 4 → load only savedPanchayatName

    if (roleId === 1 || roleId === 2) {
      if (blockFilter.length > 0) {
        const selectedBlocks = blocks.filter((b) =>
          blockFilter.includes(b.name)
        );
        const combined = selectedBlocks.flatMap((b) => b.panchayats || []);
        const unique = Array.from(
          new Map(combined.map((p) => [p.panchayatId, p])).values()
        );
        setPanchayats(unique);
      } else {
        setPanchayats([]);
      }
      setPanchayatFilter([]);
    } else if (roleId === 3) {
      const selectedBlock = blocks.find(
        (b) => b.name?.toLowerCase() === savedBlockName?.toLowerCase()
      );
      setPanchayats(selectedBlock?.panchayats || []);
    } else if (roleId === 4) {
      // Only show that one panchayat
      setPanchayats([{ name: savedPanchayatName, panchayatId: 0 }]);
      setPanchayatFilter([savedPanchayatName]);
    }
  }, [blockFilter, blocks, roleId, savedBlockName, savedPanchayatName]);

  // ✅ Filter Sheds (including date range)
  const filteredData = sheds.filter(
    (d) => {
      const matchesSearch = !search ||
        d.blockName.toLowerCase().includes(search.toLowerCase()) ||
        d.panchayatName.toLowerCase().includes(search.toLowerCase());
      
      const matchesBlock = blockFilter.length === 0 || blockFilter.includes(d.blockName);
      const matchesPanchayat = panchayatFilter.length === 0 || panchayatFilter.includes(d.panchayatName);
      
      // Date range filtering
      const matchesDateRange = (() => {
        if (!fromDate || !toDate || !d.date) return true;
        const entryDate = new Date(d.date);
        const from = new Date(fromDate);
        const to = new Date(toDate);
        // Set time to start/end of day for accurate comparison
        from.setHours(0, 0, 0, 0);
        to.setHours(23, 59, 59, 999);
        return entryDate >= from && entryDate <= to;
      })();
      
      return matchesSearch && matchesBlock && matchesPanchayat && matchesDateRange;
    }
  );

  // ✅ Reset filters when date range changes
  useEffect(() => {
    // This effect ensures the component re-renders when date filters change
  }, [fromDate, toDate, applyClicked]);

  return (
    <div className="p-0 cursor-default select-none">
      {/* 🔹 Filter Bar */}
     <div className="flex items-center gap-3 px-3 py-1 rounded-lg bg-white flex-shrink-0">

        {/* Left Section - Search and Dropdowns */}
        <div className="flex items-center gap-3 flex-1">
          {/* 🔍 Search Input */}
          <div className="flex-shrink-0">
            <StyledInput
              placeholder="Search by Block / Panchayat..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Block Dropdown */}
          {(roleId === 1 || roleId === 2 || roleId === 3) && (
            <FormControl sx={{ minWidth: 200 }} size="small">
              <InputLabel shrink={true}>Blocks</InputLabel>
              <Select
                multiple
                displayEmpty
                value={Array.isArray(blockFilter) ? blockFilter : []}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.includes("selectAll")) return;
                  setBlockFilter(value);
                }}
                input={<OutlinedInput label="Blocks" />}
                renderValue={(selected) => {
                  if (roleId === 3 && savedBlockName) return savedBlockName;
                  if (selected.length === 0) return "Select Blocks";
                  return `${selected.length} Selected`;
                }}
                MenuProps={{ PaperProps: { style: { maxHeight: 300, width: 180 } } }}
                disabled={roleId === 3}
              >
                <MenuItem
                  value="selectAll"
                  onClick={() => {
                    if (blockFilter.length === visibleBlocks.length) {
                      setBlockFilter([]);
                    } else {
                      setBlockFilter(visibleBlocks.map((b) => b.name));
                    }
                  }}
                >
                  <Checkbox
                    checked={
                      blockFilter.length > 0 &&
                      blockFilter.length === visibleBlocks.length
                    }
                    indeterminate={
                      blockFilter.length > 0 &&
                      blockFilter.length < visibleBlocks.length
                    }
                    sx={{ p: 0.3, transform: "scale(0.9)" }}
                  />
                  <ListItemText
                    primary="Select All"
                    primaryTypographyProps={{
                      fontSize: "0.8rem",
                      fontWeight: 600,
                    }}
                  />
                </MenuItem>

                {visibleBlocks.map((block) => (
                  <MenuItem
                    key={block.blockId}
                    value={block.name}
                    sx={{ py: 0.3, minHeight: "28px" }}
                  >
                    <Checkbox
                      checked={blockFilter.includes(block.name)}
                      sx={{ p: 0.3, transform: "scale(0.9)" }}
                    />
                    <ListItemText
                      primary={block.name}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {/* Panchayat Dropdown */}
          <FormControl sx={{ minWidth: 200 }} size="small">
            <InputLabel shrink={true}>Panchayats</InputLabel>
            <Select
              multiple
              displayEmpty
              value={
                roleId === 4 && savedPanchayatName
                  ? [savedPanchayatName]
                  : Array.isArray(panchayatFilter)
                  ? panchayatFilter
                  : []
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value.includes("selectAll")) return;
                setPanchayatFilter(value);
              }}
              input={<OutlinedInput label="Panchayats" />}
              renderValue={(selected) => {
                if (roleId === 4 && savedPanchayatName) return savedPanchayatName;
                if (selected.length === 0) return "Select Panchayats";
                return `${selected.length} Selected`;
              }}
              disabled={roleId === 4}
              MenuProps={{ PaperProps: { style: { maxHeight: 300, width: 180 } } }}
            >
              {panchayats.length > 0 && (
                <MenuItem
                  value="selectAll"
                  onClick={() => {
                    if (panchayatFilter.length === panchayats.length) {
                      setPanchayatFilter([]);
                    } else {
                      setPanchayatFilter(panchayats.map((p) => p.name));
                    }
                  }}
                >
                  <Checkbox
                    checked={
                      panchayatFilter.length > 0 &&
                      panchayatFilter.length === panchayats.length
                    }
                    indeterminate={
                      panchayatFilter.length > 0 &&
                      panchayatFilter.length < panchayats.length
                    }
                    sx={{ p: 0.3, transform: "scale(0.9)" }}
                  />
                  <ListItemText
                    primary="Select All"
                    primaryTypographyProps={{
                      fontSize: "0.8rem",
                      fontWeight: 600,
                    }}
                  />
                </MenuItem>
              )}

              {panchayats.length > 0 ? (
                panchayats.map((p, idx) => (
                  <MenuItem key={idx} value={p.name} sx={{ py: 0.3, minHeight: "28px" }}>
                    <Checkbox
                      checked={panchayatFilter.includes(p.name)}
                      sx={{ p: 0.3, transform: "scale(0.9)" }}
                    />
                    <ListItemText
                      primary={p.name}
                      primaryTypographyProps={{ fontSize: "0.8rem" }}
                    />
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled sx={{ fontSize: "0.8rem", color: "#888" }}>
                  No Panchayats Available
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </div>

        {/* Right Section - Date Filter */}
        <div className="flex items-center gap-3">
          {/* Quick Filter Buttons */}
          <div className="flex items-center gap-2">
            {["Today", "Week", "Month"].map((range) => (
              <ModernButton
                key={range}
                onClick={() => handleDateFilter(range)}
                isActive={activeRange === range}
                variant={activeRange === range ? "active" : "default"}
              >
                {range}
              </ModernButton>
            ))}
          </div>

          {/* Calendar Date Range Picker */}
          <div className="relative">
            <div className="flex items-center gap-3 px-3 py-1 border-2 border-purple-600 rounded-lg bg-white">
              <DatePicker
                selected={fromDate ? new Date(fromDate) : null}
                onChange={(date) => {
                  if (!date) { setFromDate(""); return; }
                  const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
                  setFromDate(fmt(date));
                }}
                customInput={<IconDateButton label={fromDate ? moment(fromDate).format('MMM D, YYYY') : 'From'} />}
                popperPlacement="bottom-start"
                dateFormat="MMM d, yyyy"
                maxDate={toDate ? new Date(toDate) : new Date()}
              />

              <DatePicker
                selected={toDate ? new Date(toDate) : null}
                onChange={(date) => {
                  if (!date) { setToDate(""); return; }
                  const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
                  setToDate(fmt(date));
                }}
                customInput={<IconDateButton label={toDate ? moment(toDate).format('MMM D, YYYY') : 'To'} />}
                popperPlacement="bottom-start"
                dateFormat="MMM d, yyyy"
                minDate={fromDate ? new Date(fromDate) : null}
                maxDate={new Date()}
              />
            </div>
          </div>
        </div>
      </div>

      {/* 🗺️ Map Section */}
      <div className="h-[600px] w-full mt-4">
       <MapContainer
  center={[12.9716, 77.5946]}
  zoom={8}
  scrollWheelZoom={true}
  style={{ height: "100%", width: "100%" }}
>
  <TileLayer
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  />

  <MapAutoFocus sheds={filteredData} />

  {filteredData.map((shed) => (
    <Marker 
      key={shed.shedId} 
      position={[shed.latStart, shed.longStart]}
      icon={compostShedIcon}
    >
      <Popup maxWidth={280} className="custom-popup" closeButton={true}>
        <div className="bg-white rounded-lg overflow-hidden shadow-md">
          {/* Header with Image */}
          <div className="relative">
            <img 
              src="/images/Compost_shed_preview.png" 
              alt="Compost Shed Preview"
              className="w-full h-32 object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            {/* Fallback if image doesn't load */}
            <div className="w-full h-32 bg-green-100 flex items-center justify-center text-green-600 text-3xl" style={{display: 'none'}}>
              🏭
            </div>
            
            {/* Shed ID Badge */}
            <div className="absolute top-2 right-2 bg-green-600 text-white px-2 py-1 rounded text-xs font-semibold">
              Shed #{shed.shedId}
            </div>
          </div>
          
          {/* Content */}
          <div className="p-3">
            <div className="text-center mb-3">
              <h3 className="font-bold text-green-700 text-lg">
                Compost Shed #{shed.shedId}
              </h3>
              <p className="text-gray-500 text-xs">Waste Management Facility</p>
            </div>
            
            <div className="space-y-2 text-sm">
              <div>
                <strong className="text-gray-700">Block:</strong>
                <span className="ml-1 text-gray-900">{shed.blockName}</span>
              </div>
              
              <div>
                <strong className="text-gray-700">Panchayat:</strong>
                <span className="ml-1 text-gray-900">{shed.panchayatName}</span>
              </div>
              
              <div className="border-t pt-2 mt-2">
                <div className="text-gray-700 font-medium mb-1">Coordinates:</div>
                <div className="text-xs text-gray-600 ml-2">
                  <div>Lat: {shed.latStart} to {shed.latEnd}</div>
                  <div>Long: {shed.longStart} to {shed.longEnd}</div>
                </div>
              </div>
              
              {shed.capacity && (
                <div>
                  <strong className="text-gray-700">Capacity:</strong>
                  <span className="ml-1 text-gray-900">{shed.capacity}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </Marker>
  ))}
</MapContainer>
      </div>
    </div>
  );
}
